import Link from 'next/link';
import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import { formatRub, type TariffRecommendation } from '../../lib';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

interface TariffCardProps {
	tariff: TariffRecommendation;
}

export function TariffCard({ tariff }: TariffCardProps) {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	return (
		<article className={styles.tariffCard}>
			<div className={styles.tariffTop}>
				<div className={styles.tariffInfo}>
					<span className={`${styles.eyebrow} ${styles.tariffEyebrow}`}>
						{t('results.recommendation')}
					</span>
					<h3>{t('results.tariff-name', { name: tariff.name })}</h3>
					<p>{tariff.description}</p>
					<Link
						className={styles.tariffCompareLink}
						href="https://fishplace.ru/#tariffs"
						target="_blank"
						rel="noopener noreferrer"
					>
						{t('results.compare-tariffs')}
					</Link>
				</div>
				<div className={styles.tariffPrice}>
					<strong>{formatRub(tariff.price)}</strong>
					<span>{t('results.price-note')}</span>
				</div>
			</div>
			<div className={styles.tariffCtaRow}>
				<Link
					className={styles.tariffCta}
					href="/registration"
					target="_blank"
					rel="noopener noreferrer"
				>
					{t('results.start-free')}
				</Link>
			</div>
		</article>
	);
}
